import {
    CallingTheme,
    CameraButton,
    ControlBar,
    DevicesButton,
    EndCallButton,
    usePropsFor,
    useTheme,
} from "@azure/communication-react";
import React, { useCallback, useMemo } from "react";
import {
    ChatButtonWithUnreadMessageCount,
    ControlBarActiveElementButton,
    controlBarButtonStyles,
    ControlBarDeviceSettingsButton,
    ControlBarParticipantsButton,
    controlBarStyles,
    DeviceSettingsDialog,
    EndCallButtonWithConfirm,
    ControlBarScreenShareButton,
    ControlBarMicrophoneButton,
    ControlBarCameraButton,
} from "live-lesson/shared/feature-call-ui-react";
import { useAppContext } from "../app-state/AppContext";
import { useBoolean } from "@fluentui/react-hooks";
import { Theme } from "@fluentui/react";

interface PcpControlBarProps {
    //** Toggles "isShowingActiveElement" property. */
    toggleActiveElement: () => void;
    setCallEnded: (ended: boolean) => void;
    isShowingActiveElement: boolean;
    isChatOpen: boolean;
    isParticipantsOpen: boolean;
};

export function PcpControlBar(props: PcpControlBarProps): JSX.Element {
    const endCallProps = usePropsFor(EndCallButton);
    const devicesButtonProps = usePropsFor(DevicesButton);

    const toggleChat = () => toggleSidePaneContent('chat');
    const toggleParticipants = () => toggleSidePaneContent('participants');
    const { toggleSidePaneContent } = useAppContext();
    const [isDeviceSettingsOpen, { setTrue: openDeviceSettings, setFalse: closeDeviceSettings }] = useBoolean(false);

    const onHangup = useCallback(async (): Promise<void> => {
        await endCallProps.onHangUp();
        props.setCallEnded(true);
    }, [endCallProps]);

    const themeV8 = useTheme() as Theme & CallingTheme;  //using value of "FluentThemeProvider" component
    const controlBarButtonStylesMemo = useMemo(() => controlBarButtonStyles(themeV8), [themeV8]);

    return <ControlBar layout="horizontal" styles={controlBarStyles()}>
        <ControlBarMicrophoneButton styles={controlBarButtonStylesMemo} />
        <ControlBarCameraButton styles={controlBarButtonStylesMemo} />
        <ControlBarParticipantsButton
            checked={props.isParticipantsOpen}
            onClick={toggleParticipants}
            styles={controlBarButtonStylesMemo}
        />
        <ChatButtonWithUnreadMessageCount
            onClick={toggleChat}
            checked={props.isChatOpen}
            styles={controlBarButtonStylesMemo}
        />
        <ControlBarDeviceSettingsButton
            styles={controlBarButtonStylesMemo}
            onClick={openDeviceSettings}
            checked={isDeviceSettingsOpen}
        />
        <ControlBarScreenShareButton styles={controlBarButtonStylesMemo} />
        <DeviceSettingsDialog isOpen={isDeviceSettingsOpen} onClose={closeDeviceSettings} />

        <ControlBarActiveElementButton
            onClick={props.toggleActiveElement}
            checked={props.isShowingActiveElement}
            styles={controlBarButtonStylesMemo}
        />
        {endCallProps && <EndCallButtonWithConfirm
            {...endCallProps}
            onHangUp={onHangup}

            title={'Unterricht verlassen'}
            content={'Möchten Sie den Unterricht wirklich verlassen?'}
        />}
    </ControlBar>
}
